import React from 'react';
import i18next from 'i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';

import Breakpoints from 'lib/Breakpoints';

import Related from 'components/Related';
import GiftGuide from 'components/GiftGuide';

const mapStateToProps = (state) => {
  const taxonomy = get(state, 'article.content[0].taxonomy');
  const articleID = get(state, 'article.content[0].id');
  return {
    taxonomy,
    articleID,
  };
};

class Recommended extends React.Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    isGiftGuide: PropTypes.bool,
    isNBCNewsCommerce: PropTypes.bool,
    isBetterNewsCommerce: PropTypes.bool,
    isRightRail: PropTypes.bool,
    isTrending: PropTypes.bool,
    mobile: PropTypes.bool,
    taxonomy: PropTypes.shape({
      primarySection: PropTypes.shape({
        id: PropTypes.string,
      }),
      primaryTopic: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
    articleID: PropTypes.string,
  };

  static defaultProps = {
    additionalClasses: '',
    isGiftGuide: false,
    isNBCNewsCommerce: false,
    isBetterNewsCommerce: false,
    isRightRail: false,
    isTrending: false,
    mobile: true,
    taxonomy: {},
    articleID: '',
  };

  getType = () => {
    const {
      isGiftGuide,
      isTrending,
      isNBCNewsCommerce,
      isBetterNewsCommerce,
    } = this.props;
    if (isTrending && !isBetterNewsCommerce) {
      return 'trending';
    }
    if (isGiftGuide) {
      return 'giftGuide';
    }
    if (isNBCNewsCommerce) {
      return 'nbcNewsCommerce';
    }
    if (isBetterNewsCommerce) {
      return 'betterNewsCommerce';
    }
    return 'article';
  }

  getLimit = () => {
    const { isGiftGuide, isTrending, isNBCNewsCommerce } = this.props;
    if (isTrending || isGiftGuide) {
      return 5;
    }
    if (isNBCNewsCommerce) {
      return 4;
    }
    return Breakpoints.isS() ? 1 : 2;
  }

  shouldShow = () => {
    const {
      mobile,
      isTrending,
      isGiftGuide,
      isNBCNewsCommerce,
      isBetterNewsCommerce,
    } = this.props;
    if (isTrending || isGiftGuide || isNBCNewsCommerce || isBetterNewsCommerce) {
      return true;
    }
    return (mobile && Breakpoints.isSorM()) || (!mobile && Breakpoints.isLorXL());
  }

  render() {
    const {
      additionalClasses,
      isGiftGuide,
      isNBCNewsCommerce,
      isBetterNewsCommerce,
      isRightRail,
      isTrending,
      taxonomy,
      articleID,
    } = this.props;

    const shouldRenderTwoItems = !isRightRail && !isNBCNewsCommerce;
    const NUMBER_TO_SLICE_BY = shouldRenderTwoItems ? 2 : 4;
    const mainPrimaryTopicName = get(taxonomy, 'primaryTopic.name');
    const items = get(taxonomy, 'primaryTopic.content.items');
    const resolvedItems = Array.isArray(items) && items
      .reduce((resolved, item) => {
        if (!Object.keys(item).length) return resolved;

        const relatedItemPrimaryTopicName = get(item, 'taxonomy.primaryTopic.name');
        const relatedItemID = get(item, 'id');
        if (mainPrimaryTopicName !== relatedItemPrimaryTopicName) return resolved;
        if (articleID === relatedItemID) return resolved;

        const thumbnail = get(item, 'primaryImage.url.primary');
        const unibrow = {
          url: get(item, 'unibrow.url'),
          text: get(item, 'unibrow.text'),
        };
        const title = get(item, 'headline.tease');
        const url = get(item, 'url.primary');
        const { id, type } = item;
        const resolvedItem = {
          id,
          url,
          type,
          title,
          unibrow,
          thumbnail,
        };

        resolved.push(resolvedItem);
        return resolved;
      }, []);

    // No results, return early
    if (!Array.isArray(resolvedItems) || !resolvedItems.length) {
      return null;
    }

    const title = isTrending ? i18next.t('Trending') : i18next.t('Recommended');
    const id = title.toLowerCase();

    let linkTrackingID;
    if (isTrending || isNBCNewsCommerce) {
      linkTrackingID = 'recommended_shop';
    } else {
      linkTrackingID = id;
    }

    if (isGiftGuide) {
      return (
        <GiftGuide
          items={resolvedItems}
          data-test="gift-guide"
        />
      );
    }

    if (this.shouldShow()) {
      return (
        <Related
          additionalClasses={additionalClasses}
          elementId={id}
          isNBCNewsCommerce={isNBCNewsCommerce}
          isBetterNewsCommerce={isBetterNewsCommerce}
          isRightRail={isRightRail}
          isTrending={isTrending}
          items={resolvedItems.slice(0, NUMBER_TO_SLICE_BY)}
          linkTracking={linkTrackingID}
          title={title}
        />
      );
    }

    return null;
  }
}

export default connect(mapStateToProps)(Recommended);
